import { Status } from '../typings/chat';

export const shouldIgnoreMessageError = (status: Status) => {
  return status === Status.DELIVERED || status === Status.READ;
};
